<mat-toolbar class="header" role="banner">
  <div class="header-container">
    <!-- Logo -->
    <div
      class="logo"
      [routerLink]="['/home']"
      role="button"
      tabindex="0"
      [attr.aria-label]="'header.logo_home' | translate"
      (keydown.enter)="navigateHome()"
      (keydown.space)="$event.preventDefault(); navigateHome()"
    >
      <img
        src="assets/logo.webp"
        alt="SOS Corp Logo"
        class="logo-image"
        width="60"
        height="60"
      />
      <span class="logo-text">SOS Corp</span>
    </div>

    <!-- Desktop Navigation -->
    <nav
      class="desktop-nav"
      role="navigation"
      [attr.aria-label]="'header.main_navigation' | translate"
    >
      @for (item of navItems; track item.route) {
      <a
        mat-button
        [routerLink]="item.route"
        routerLinkActive="active-link"
        class="nav-link"
        [attr.aria-current]="item.route === currentRoute() ? 'page' : null"
      >
        {{ item.labelKey | translate }}
      </a>
      }
    </nav>

    <!-- Actions -->
    <div class="actions">
      <!-- Music Toggle -->
      <button
        mat-icon-button
        (click)="toggleMusic()"
        class="music-button"
        [attr.aria-label]="
          (audioService.isPlaying()
            ? 'header.pause_music'
            : 'header.play_music'
          ) | translate
        "
        [attr.aria-pressed]="audioService.isPlaying()"
      >
        <mat-icon aria-hidden="true">
          {{ audioService.isPlaying() ? 'pause_circle' : 'play_circle' }}
        </mat-icon>
      </button>

      <!-- Language Switcher -->
      <button
        mat-icon-button
        [matMenuTriggerFor]="langMenu"
        class="lang-button"
        [attr.aria-label]="'header.language_selector' | translate"
      >
        <mat-icon aria-hidden="true">language</mat-icon>
      </button>
      <mat-menu #langMenu="matMenu">
        <button
          mat-menu-item
          (click)="switchLanguage('en')"
          [attr.aria-current]="currentLang() === 'en' ? 'true' : null"
        >
          <mat-icon aria-hidden="true">
            {{ currentLang() === 'en' ? 'check' : '' }}
          </mat-icon>
          <span>English</span>
        </button>
        <button
          mat-menu-item
          (click)="switchLanguage('fr')"
          [attr.aria-current]="currentLang() === 'fr' ? 'true' : null"
        >
          <mat-icon aria-hidden="true">
            {{ currentLang() === 'fr' ? 'check' : '' }}
          </mat-icon>
          <span>Français</span>
        </button>
      </mat-menu>

      <!-- Mobile Menu Toggle -->
      <button
        mat-icon-button
        class="mobile-menu-button"
        (click)="toggleMobileMenu()"
        [attr.aria-label]="
          (mobileMenuOpen() ? 'header.close_menu' : 'header.open_menu')
            | translate
        "
        [attr.aria-expanded]="mobileMenuOpen()"
      >
        <mat-icon aria-hidden="true">
          {{ mobileMenuOpen() ? 'close' : 'menu' }}
        </mat-icon>
      </button>
    </div>
  </div>
</mat-toolbar>

<!-- Mobile Navigation -->
<nav
  class="mobile-nav"
  [class.is-open]="mobileMenuOpen()"
  role="navigation"
  [attr.aria-label]="'header.mobile_navigation' | translate"
  [attr.aria-hidden]="!mobileMenuOpen()"
>
  @for (item of navItems; track item.route) {
  <a
    mat-button
    [routerLink]="item.route"
    routerLinkActive="active-link"
    class="mobile-nav-link"
    (click)="closeMobileMenu()"
    [attr.aria-current]="item.route === currentRoute() ? 'page' : null"
    [tabindex]="mobileMenuOpen() ? 0 : -1"
  >
    <mat-icon aria-hidden="true">{{ item.icon }}</mat-icon>
    <span>{{ item.labelKey | translate }}</span>
  </a>
  }
</nav>
